import CONFIG from '../page.config'

const updateSessionToken = (token) => {
    if(!token) return

    const session = JSON.parse(sessionStorage.getItem('wiks@session')) || null
    if(!session) return

    session.token_session = token
    sessionStorage.setItem('wiks@session', JSON.stringify(session))
}

const closeSession = () => {
    sessionStorage.removeItem('wiks@session')
    sessionStorage.removeItem('encrypted')

    const loginUrl = new URL(process.env.BASE_URL || '/', window.location.origin)
    window.location.replace(loginUrl.href)
}

const addQueryParams = (url, query) => {
    if(!query) return url

    const queryString = new URLSearchParams(query).toString()
    if(!queryString) return url

    const separator = url.includes('?') ? '&' : '?'
    return `${url}${separator}${queryString}`
}

const prepareRequestBody = (request, headers, body) => {
    if(body === null) return

    const isMultipart = headers['Content-Type'] === 'multipart/form-data'

    if(body instanceof FormData || isMultipart) {
        delete headers['Content-Type']
        request.body = body instanceof FormData
            ? body
            : Object.entries(body).reduce((formData, [key, value]) => {
                formData.append(key, value)
                return formData
            }, new FormData())
        return
    }

    request.body = headers['Content-Type']
        ? JSON.stringify(body)
        : body
}

const readResponse = async (res) => {
    const contentType = res.headers.get('content-type') || ''

    if(contentType.includes('application/json')) {
        return res.json()
    }

    const data = await res.text()
    return {
        http: res.status,
        data
    }
}

export default async function sendRequest(url = null, method = 'GET', params = null,body = null, query = null, custom_headers = null) {
    if(!url) {
        return {
            success: false,
            errors: [{ code: 'missing_url', message: 'URL no especificada' }]
        }
    }

    try {
        const configuredHeaders = custom_headers ?? CONFIG.server[CONFIG.env].headers
        const headers = { ...configuredHeaders }
        const request = {
            method,
            headers,
            cache: 'no-store'
        }
        let requestUrl = `${CONFIG.server[CONFIG.env].api}/${url}`

        requestUrl = addQueryParams(requestUrl, query)

        if(params !== null && query === null) {
            request.params = JSON.stringify(params)
        }

        if(method !== 'GET' || query === null) {
            prepareRequestBody(request, headers, body)
        }

        const res = await fetch(requestUrl, request)
        updateSessionToken(res.headers.get('session'))

        const response = await readResponse(res)
        const httpCode = Number(response?.http ?? res.status)
        const data = response?.data ?? null
        const errors = response?.errors ?? null

        switch(httpCode) {
            case 200:
            case 201:
                if(data !== null) {
                    return { success: true, data }
                }
                break

            case 400:
            case 202:
            case 403:
                return { success: false, errors }

            case 304:
            case 404:
                return {
                    success: false,
                    error: [{ code: 404, message: 'Url not found' }]
                }

            case 401:
                closeSession()
                return {
                    success: false,
                    errors: errors || [{ code: 401, message: 'Acceso no autorizado' }]
                }

            case 500:
            case 502:
            case 503:
                return {
                    success: false,
                    errors: errors || [{ code: httpCode, message: 'Error del servidor' }]
                }
        }

        if(res.ok && data !== null) {
            return { success: true, data }
        }

        return {
            success: false,
            errors: errors || [{
                code: httpCode,
                message: 'Respuesta no reconocida'
            }]
        }
    }
    catch(error) {
        console.error('[API]', method, url, error)

        return {
            success: false,
            errors: [{
                code: 'request_error',
                message: error.message || 'Error en la petición'
            }]
        }
    }
}
